

<div class="min-h-screen bg-slate-50 p-4 font-sans antialiased text-slate-800 space-y-6">
      <div class="max-w-[1400px] mx-auto space-y-6">

            <div class="space-y-2">
                  <div
                        class="bg-white rounded-md shadow-sm border border-slate-200 p-3 flex items-center justify-between">
                        <div>
                              <h2 class="text-xs font-bold text-slate-800 uppercase tracking-wider">Tax Matrix
                                    Optimization Rules</h2>
                              <p class="text-[10px] text-slate-400 uppercase font-medium">Map criteria filters against
                                    conditional relational parameters</p>
                        </div>
                        <button (click)="openRuleModal()"
                              class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-[10px] font-bold uppercase tracking-tight transition-all shadow-sm">
                              + Add New Matrix Rule
                        </button>
                  </div>

                  <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden">
                        <div class="overflow-x-auto">
                              <table class="w-full text-left border-collapse">
                                    <thead>
                                          <tr
                                                class="bg-slate-50 border-b border-slate-200 text-[9px] uppercase tracking-wider text-slate-500 font-bold">
                                                <th class="px-4 py-2">Transaction Specs</th>
                                                <th class="px-4 py-2">Entity Context Filters</th>
                                                <th class="px-4 py-2">Target Tax Group Output</th>
                                                <th class="px-4 py-2">Dynamic Logic Constraints</th>
                                                <th class="px-4 py-2">Status</th>
                                                <th class="px-4 py-2 text-right">Actions</th>
                                          </tr>
                                    </thead>
                                    <tbody class="divide-y divide-slate-100 text-xs">
                                          <tr *ngFor="let rule of taxRules" class="hover:bg-slate-50 transition-colors">
                                                <td class="px-4 py-2">
                                                      <span class="font-bold block text-slate-700">{{
                                                            rule.transactionType }}</span>
                                                      <span class="text-[9px] text-slate-400 block font-mono">Weight: {{
                                                            rule.priority }}</span>
                                                </td>
                                                <td class="px-4 py-2">
                                                      <div
                                                            class="grid grid-cols-2 gap-x-2 gap-y-0.5 text-[10px] text-slate-500 font-medium">
                                                            <div><span class="text-slate-400">Org:</span> {{ rule.orgId
                                                                  ? 'Assigned' : 'Global' }}</div>
                                                            <div><span class="text-slate-400">Cust Grp:</span> {{
                                                                  rule.customerGroupId || 'All' }}</div>
                                                            <div><span class="text-slate-400">Item Grp:</span> {{
                                                                  rule.itemGroupId || 'All' }}</div>
                                                            <div><span class="text-slate-400">Country:</span> {{
                                                                  rule.countryId || 'Any' }}</div>
                                                      </div>
                                                </td>
                                                <td class="px-4 py-2">
                                                      <span
                                                            class="bg-blue-50 border border-blue-100 rounded px-1.5 py-0.5 font-mono text-[10px] font-bold text-blue-700">
                                                            {{ getGroupName(rule.taxGroupId) }}
                                                      </span>
                                                </td>
                                                <td class="px-4 py-2">
                                                      <div class="flex flex-wrap gap-1">
                                                            <span *ngFor="let cond of rule.conditions"
                                                                  class="bg-slate-100 text-slate-600 text-[9px] border px-1.5 py-0.5 rounded font-mono">
                                                                  {{ cond.fieldName }} {{ cond.operator }} "{{
                                                                  cond.fieldValue }}"
                                                            </span>
                                                            <span *ngIf="!rule.conditions?.length"
                                                                  class="text-[10px] italic text-slate-400">No
                                                                  constraints mapped</span>
                                                      </div>
                                                </td>
                                                <td class="px-4 py-2">
                                                      <span [class]="rule.isActive ? 'bg-green-50 text-green-700 border-green-200' : 'bg-slate-100 text-slate-400 border-slate-200'"
                                                            class="text-[9px] font-bold px-1.5 py-0.2 rounded border uppercase">
                                                            {{ rule.isActive ? 'Active' : 'Off' }}
                                                      </span>
                                                </td>
                                                <td class="px-4 py-2 text-right">
                                                      <div class="flex justify-end gap-1.5">
                                                            <button (click)="openRuleModal(rule)"
                                                                  class="p-1 text-slate-400 hover:text-blue-600 transition-colors">
                                                                  <svg class="w-3.5 h-3.5" fill="none"
                                                                        stroke="currentColor" stroke-width="2"
                                                                        viewBox="0 0 24 24">
                                                                        <path
                                                                              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                  </svg>
                                                            </button>
                                                            <button (click)="deleteRule(rule.id!)"
                                                                  class="p-1 text-slate-400 hover:text-red-600 transition-colors">
                                                                  <svg class="w-3.5 h-3.5" fill="none"
                                                                        stroke="currentColor" stroke-width="2"
                                                                        viewBox="0 0 24 24">
                                                                        <path
                                                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                  </svg>
                                                            </button>
                                                      </div>
                                                </td>
                                          </tr>
                                    </tbody>
                              </table>
                        </div>
                  </div>
            </div>


            <div class="space-y-2">
                  <div
                        class="bg-white rounded-md shadow-sm border border-slate-200 p-3 flex items-center justify-between">
                        <div>
                              <h2 class="text-xs font-bold text-slate-800 uppercase tracking-wider">Tax Formula Rate
                                    Groups</h2>
                              <p class="text-[10px] text-slate-400 uppercase font-medium">Review composition buckets and
                                    inner compound itemized lines structures</p>
                        </div>
                        <button (click)="openGroupModal()"
                              class="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1 rounded text-[10px] font-bold uppercase tracking-tight transition-all shadow-sm">
                              + Add New Formula Group
                        </button>
                  </div>

                  <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden">
                        <div class="overflow-x-auto">
                              <table class="w-full text-left border-collapse">
                                    <thead>
                                          <tr
                                                class="bg-slate-50 border-b border-slate-200 text-[9px] uppercase tracking-wider text-slate-500 font-bold">
                                                <th class="px-4 py-2">Identification Code</th>
                                                <th class="px-4 py-2">Descriptive Alias</th>
                                                <th class="px-4 py-2">Tax Mechanism Type</th>
                                                <th class="px-4 py-2">Itemized Breakdown Components Structure Lines</th>
                                                <th class="px-4 py-2">Tax Integration Status</th>
                                                <th class="px-4 py-2 text-right">Actions</th>
                                          </tr>
                                    </thead>
                                    <tbody class="divide-y divide-slate-100 text-xs">
                                          <tr *ngFor="let group of taxGroups"
                                                class="hover:bg-slate-50 transition-colors">
                                                <td class="px-4 py-2 font-mono font-bold text-slate-700">{{ group.code
                                                      || 'UNNAMED' }}</td>
                                                <td class="px-4 py-2 font-medium text-slate-600">{{ group.name ||
                                                      'System Auto-generated Base' }}</td>
                                                <td class="px-4 py-2">
                                                      <span
                                                            class="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-slate-100 border text-slate-600">
                                                            {{ group.taxType || 'Manual Base' }}
                                                      </span>
                                                </td>
                                                <td class="px-4 py-2">
                                                      <div class="flex flex-wrap gap-1.5">
                                                            <div *ngFor="let line of group.lines"
                                                                  class="bg-slate-50 border border-slate-200 rounded px-1.5 py-0.5 text-[10px] text-slate-600">
                                                                  <span class="font-bold text-slate-800">{{ line.taxCode
                                                                        }}:</span> {{ line.rate }}%
                                                                  <span class="text-[9px] text-slate-400 font-mono">({{
                                                                        line.calculationMethod }})</span>
                                                            </div>
                                                            <span *ngIf="!group.lines?.length"
                                                                  class="text-[10px] italic text-slate-400">Zero
                                                                  subcomponents declared</span>
                                                      </div>
                                                </td>
                                                <td class="px-4 py-2">
                                                      <span [class]="group.isActive ? 'bg-green-50 text-green-700 border-green-200' : 'bg-slate-100 text-slate-400 border-slate-200'"
                                                            class="text-[9px] font-bold px-1.5 py-0.2 rounded border uppercase">
                                                            {{ group.isActive ? 'Active' : 'Off' }}
                                                      </span>
                                                </td>
                                                <td class="px-4 py-2 text-right">
                                                      <div class="flex justify-end gap-1.5">
                                                            <button (click)="openGroupModal(group)"
                                                                  class="p-1 text-slate-400 hover:text-emerald-600 transition-colors">
                                                                  <svg class="w-3.5 h-3.5" fill="none"
                                                                        stroke="currentColor" stroke-width="2"
                                                                        viewBox="0 0 24 24">
                                                                        <path
                                                                              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                  </svg>
                                                            </button>
                                                            <button (click)="deleteGroup(group.id!)"
                                                                  class="p-1 text-slate-400 hover:text-red-600 transition-colors">
                                                                  <svg class="w-3.5 h-3.5" fill="none"
                                                                        stroke="currentColor" stroke-width="2"
                                                                        viewBox="0 0 24 24">
                                                                        <path
                                                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                  </svg>
                                                            </button>
                                                      </div>
                                                </td>
                                          </tr>
                                    </tbody>
                              </table>
                        </div>
                  </div>
            </div>

      </div>
</div>


<div *ngIf="activeModal === 'rule'"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-xs p-4 overflow-y-auto">
      <div
            class="bg-white w-full max-w-4xl rounded-md shadow-xl border border-slate-200 overflow-hidden my-auto text-xs">
            <div class="px-4 py-3 bg-slate-50 border-b border-slate-200 flex justify-between items-center">
                  <div>
                        <h3 class="text-xs font-bold uppercase text-slate-700">{{ isEdit ? 'Update' : 'Register' }}
                              Financial Tax Match Route</h3>
                        <p class="text-[9px] text-slate-400 uppercase font-medium">Relational database matrix mappings
                        </p>
                  </div>
                  <button (click)="closeModal()" class="text-slate-400 hover:text-slate-600 text-lg">&times;</button>
            </div>

            <form [formGroup]="ruleForm" (ngSubmit)="submitRule()" class="p-4 space-y-4">
                  <div class="grid grid-cols-4 gap-3">
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Enterprise
                                    Context Org</label>
                              <select formControlName="orgId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <!-- <option [value]="null">Global Fallback Engine</option> -->
                                    <option [value]="null">-- Org Id (Global Shared) --</option>
                                    <option *ngFor="let item of organisations" [value]="item.id">{{ item.name }}
                                    </option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Customer
                                    Strategy Group</label>
                              <select formControlName="customerGroupId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <option [value]="null">All Customer Profiles</option>
                                    <option *ngFor="let item of customerGroups" [value]="item.id">{{ item.name }}
                                    </option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Inventory Item
                                    Group</label>
                              <select formControlName="itemGroupId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <option [value]="null">All Products Categories</option>
                                    <option *ngFor="let item of itemGroups" [value]="item.id">{{ item.name }}</option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Warehouse Source
                                    Location State</label>
                              <select formControlName="warehouseStateId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <option [value]="null">Any Sourcing Warehouse State</option>
                                    <option *ngFor="let item of states" [value]="item.id">{{ item.name }}</option>
                              </select>
                        </div>
                  </div>

                  <div class="grid grid-cols-4 gap-3">
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Customer
                                    Delivery State</label>
                              <select formControlName="customerStateId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <option [value]="null">Any Destination Destination State</option>
                                    <option *ngFor="let item of states" [value]="item.id">{{ item.name }}</option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Country Code
                                    Boundary</label>
                              <select formControlName="countryId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <option [value]="null">International (Global Cross Border)</option>
                                    <option *ngFor="let item of countries" [value]="item.id">{{ item.name }}</option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Transaction
                                    Currency</label>
                              <select formControlName="currencyId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <option [value]="null">Multi-currency Universal</option>
                                    <option *ngFor="let item of currencies" [value]="item.id">{{ item.name }}</option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Fiscal Position
                                    Frame</label>
                              <select formControlName="fiscalPositionId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <option [value]="null">Default Structural Calculations</option>
                                    <option *ngFor="let item of fiscalPositions" [value]="item.id">{{ item.name }}
                                    </option>
                              </select>
                        </div>
                  </div>

                  <div class="grid grid-cols-4 gap-3">
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Transaction
                                    Type</label>
                              <select formControlName="transactionType"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white">
                                    <option value="Sales">Sales </option>
                                    <option value="Purchase">Purchase </option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Evaluation
                                    Weight Priority</label>
                              <input formControlName="priority" type="number"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 font-mono">
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Target
                                    Evaluation Formula Group</label>
                              <select formControlName="taxGroupId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-blue-500 bg-white border-blue-300 ring-1 ring-blue-50">
                                    <option [value]="null">Choose Formula Rule Block...</option>
                                    <option *ngFor="let g of taxGroups" [value]="g.id">{{ g.name || g.code }}</option>
                              </select>
                        </div>
                        <div class="flex items-center h-full pt-3">
                              <label class="flex items-center gap-2 cursor-pointer selection:bg-transparent">
                                    <input type="checkbox" formControlName="isActive"
                                          class="rounded text-blue-600 focus:ring-0">
                                    <span class="text-[10px] font-bold text-slate-600 uppercase">Deploy Engine State
                                          Active</span>
                              </label>
                        </div>
                  </div>

                  <div class="border border-slate-200 rounded bg-slate-50 p-3 space-y-2">
                        <div class="flex justify-between items-center border-b pb-1.5">
                              <span class="text-[10px] font-bold uppercase text-slate-600 tracking-wider">Dynamic Rule
                                    Match Verification Filters Array</span>
                              <button type="button" (click)="addRuleCondition()"
                                    class="bg-slate-200 text-slate-700 px-2 py-0.5 rounded text-[9px] font-bold uppercase hover:bg-slate-300">
                                    + Add Logical Row Validation Constraint
                              </button>
                        </div>
                        <div formArrayName="conditions" class="space-y-1.5 max-h-[140px] overflow-y-auto">
                              <div *ngFor="let ctrl of ruleConditions.controls; let idx = index" [formGroupName]="idx"
                                    class="flex items-center gap-2 bg-white p-1.5 border rounded shadow-2xs">
                                    <span class="text-[9px] font-mono text-slate-400 px-1 font-bold">{{ idx + 1
                                          }}</span>
                                    <input formControlName="fieldName" type="text" placeholder="Field, e.g., SubTotal"
                                          class="flex-1 px-2 py-0.5 border rounded outline-none text-[11px]">
                                    <select formControlName="operator"
                                          class="w-16 px-1 py-0.5 border rounded bg-white outline-none text-[11px]">
                                          <option value="=">=</option>
                                          <option value=">">&gt;</option>
                                          <option value="<">&lt;</option>
                                          <option value="!=">!=</option>
                                    </select>
                                    <input formControlName="fieldValue" type="text" placeholder="Value, e.g., 5000"
                                          class="flex-1 px-2 py-0.5 border rounded outline-none text-[11px]">
                                    <button type="button" (click)="removeRuleCondition(idx)"
                                          class="text-slate-300 hover:text-red-500 font-bold px-1 text-sm">&times;</button>
                              </div>
                              <p *ngIf="!ruleConditions.length"
                                    class="text-center text-slate-400 italic text-[10px] py-2">No verification
                                    properties currently constrained. This profile executes unconditionally.</p>
                        </div>
                  </div>

                  <div class="pt-3 border-t flex justify-end gap-2 text-[10px] font-bold uppercase">
                        <button type="button" (click)="closeModal()"
                              class="px-4 py-1.5 text-slate-400 hover:text-slate-600">Dismiss</button>
                        <button type="submit" [disabled]="ruleForm.invalid"
                              class="bg-blue-600 text-white px-6 py-1.5 rounded disabled:opacity-40">
                              {{ isEdit ? 'Update' : 'Save' }} Financial Matrix Route Rule
                        </button>
                  </div>
            </form>
      </div>
</div>


<div *ngIf="activeModal === 'group'"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-xs p-4 overflow-y-auto">
      <div
            class="bg-white w-full max-w-4xl rounded-md shadow-xl border border-slate-200 overflow-hidden my-auto text-xs">
            <div class="px-4 py-3 bg-slate-50 border-b border-slate-200 flex justify-between items-center">
                  <div>
                        <h3 class="text-xs font-bold uppercase text-slate-700">{{ isEdit ? 'Modify' : 'Initialize' }}
                              Dynamic Tax Formula Formula Group</h3>
                        <p class="text-[9px] text-slate-400 uppercase font-medium">Define calculation breakdown
                              structural rules sheets</p>
                  </div>
                  <button (click)="closeModal()" class="text-slate-400 hover:text-slate-600 text-lg">&times;</button>
            </div>

            <form [formGroup]="groupForm" (ngSubmit)="submitGroup()" class="p-4 space-y-4">
                  <div class="grid grid-cols-4 gap-3">
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Unique System
                                    Reference Code</label>
                              <input formControlName="code" type="text" placeholder="e.g., GST18"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-emerald-500 font-mono font-bold uppercase">
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Descriptive
                                    Evaluation Title Name</label>
                              <input formControlName="name" type="text" placeholder="e.g., Integrated GST 18%"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-emerald-500">
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Classification
                                    Variant Mechanism Category</label>
                              <select formControlName="taxType"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-emerald-500 bg-white">
                                    <option value="GST">GST System Configuration</option>
                                    <option value="VAT">VAT Accounting Structure</option>
                                    <option value="SalesTax">Retail State Sales Tax</option>
                                    <option value="Exempt">Tax Exempt / Non-Taxable Ledger</option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Base Registry
                                    Org ID</label>
                              <select formControlName="orgId"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-emerald-500 bg-white">
                                    <!-- <option [value]="null">Shared Base Global System</option> -->
                                                <option [value]="null">-- Org Id (Global Shared) --</option>
                                    <option *ngFor="let item of organisations" [value]="item.id">{{ item.name }}
                                    </option>
                              </select>
                        </div>
                  </div>

                  <div class="grid grid-cols-4 gap-3">
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Country ISO Code
                                    Mapping</label>
                              <input formControlName="countryCode" type="text" placeholder="e.g., US / IN"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-emerald-500 uppercase font-mono">
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Operational Flow
                                    Stream Mode</label>
                              <select formControlName="transactionType"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-emerald-500 bg-white">
                                    <option value="Sales">Sales Pipeline Processing</option>
                                    <option value="Purchase">Purchase Verification Ledger</option>
                              </select>
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Fiscal Code
                                    Placement Designation</label>
                              <input formControlName="fiscalPositionCode" type="text" placeholder="e.g., DOMESTIC"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-emerald-500 font-mono">
                        </div>
                        <div>
                              <label class="block text-[9px] font-bold text-slate-500 uppercase mb-0.5">Processing
                                    Priority Execution No</label>
                              <input formControlName="priorityNo" type="number"
                                    class="w-full px-2 py-1 border border-slate-200 rounded outline-none focus:border-emerald-500 font-mono">
                        </div>
                  </div>

                  <div class="grid grid-cols-2 gap-3 items-center pt-1">
                        <div class="flex items-center gap-4 bg-slate-50 border p-2 rounded">
                              <label class="flex items-center gap-2 cursor-pointer">
                                    <input type="checkbox" formControlName="isInclusive"
                                          class="rounded text-emerald-600 focus:ring-0">
                                    <span class="text-[9px] font-bold text-slate-600 uppercase">Prices Inclusive
                                          Structure (Tax Absorbed Inside Base Price) (isInclusive)</span>
                              </label>
                        </div>
                        <div class="flex items-center gap-4 bg-slate-50 border p-2 rounded">
                              <label class="flex items-center gap-2 cursor-pointer">
                                    <input type="checkbox" formControlName="isActive"
                                          class="rounded text-emerald-600 focus:ring-0">
                                    <span class="text-[9px] font-bold text-slate-600 uppercase">Enable Group Profile
                                          inside dynamic validation calls (isActive)</span>
                              </label>
                        </div>
                  </div>

                  <div class="border border-slate-200 rounded bg-slate-50 p-3 space-y-2">
                        <div class="flex justify-between items-center border-b pb-1.5">
                              <span class="text-[10px] font-bold uppercase text-slate-600 tracking-wider">Itemized
                                    Breakdown Components Composition Formula Lines Ledger</span>
                              <button type="button" (click)="addGroupLine()"
                                    class="bg-emerald-100 text-emerald-800 border border-emerald-200 px-2 py-0.5 rounded text-[9px] font-bold uppercase hover:bg-emerald-200">
                                    + Append Subcomponent Item Line Breakdown Split
                              </button>
                        </div>

                        <div formArrayName="lines" class="space-y-1.5 max-h-[160px] overflow-y-auto">
                              <div *ngFor="let ctrl of groupLines.controls; let idx = index" [formGroupName]="idx"
                                    class="flex items-center gap-2 bg-white p-2 border rounded shadow-2xs">
                                    <div class="grid grid-cols-6 gap-2 flex-1">
                                          <div>
                                                <input formControlName="taxCode" type="text"
                                                      placeholder="Code (e.g., CGST)"
                                                      class="w-full px-2 py-0.5 border rounded outline-none text-[11px] font-mono uppercase font-semibold">
                                          </div>
                                          <div class="col-span-2">
                                                <input formControlName="taxName" type="text"
                                                      placeholder="Description Name Label"
                                                      class="w-full px-2 py-0.5 border rounded outline-none text-[11px]">
                                          </div>
                                          <div>
                                                <input formControlName="rate" type="number" step="0.01"
                                                      placeholder="Rate %"
                                                      class="w-full px-2 py-0.5 border rounded outline-none font-mono text-[11px] text-right font-bold">
                                          </div>
                                          <div>
                                                <select formControlName="calculationMethod"
                                                      class="w-full px-1 py-0.5 border rounded bg-white outline-none text-[10px]">
                                                      <option value="percentage">Percentage Split</option>
                                                      <option value="fixed">Fixed Flat Dollar Value</option>
                                                </select>
                                          </div>
                                          <div class="flex items-center justify-between gap-1 pl-1">
                                                <input formControlName="sequenceNo" type="number" placeholder="Seq"
                                                      class="w-10 px-1 py-0.5 border rounded text-center text-[11px] font-mono">
                                                <label
                                                      class="flex items-center gap-1 cursor-pointer text-[9px] text-slate-500 select-none">
                                                      <input type="checkbox" formControlName="isCompound"
                                                            class="rounded text-emerald-600 scale-75 p-0 focus:ring-0">Comp.
                                                </label>
                                          </div>
                                    </div>
                                    <button type="button" (click)="removeGroupLine(idx)"
                                          class="text-slate-300 hover:text-red-500 font-bold px-1 text-sm">&times;</button>
                              </div>
                              <p *ngIf="!groupLines.length" class="text-center text-slate-400 italic text-[10px] py-2">
                                    No formula allocation splits declared. Add at least one tax breakdown row component.
                              </p>
                        </div>
                  </div>

                  <div class="pt-3 border-t flex justify-end gap-2 text-[10px] font-bold uppercase">
                        <button type="button" (click)="closeModal()"
                              class="px-4 py-1.5 text-slate-400 hover:text-slate-600">Dismiss</button>
                        <button type="submit" [disabled]="groupForm.invalid"
                              class="bg-emerald-600 text-white px-6 py-1.5 rounded disabled:opacity-40">
                              {{ isEdit ? 'Update' : 'Save' }} Tax Formula Composition Group
                        </button>
                  </div>
            </form>
      </div>
</div>